<div #containerRef class="info-container {{lang.direction}}">
  <span class="text-bock" [innerText]="textTranslated | slice : posMin :  posStart "></span>
  <span #highlightRef class="text-bock" style="background-color: {{settingsService.settings.spell.sentenceColor}};" [innerText]="textTranslated  | slice : posStart : posEnd"></span>
  <span class="text-bock" [innerText]="textTranslated  | slice : posEnd : posMax"></span>
</div>
